import Vue from "vue";
import axios from '../axios';

Vue.filter('panel-icon', function (val) {

    //return axios.getThematicPathIconUrl(val);

    let _economy = require("@/assets/img/agenda/neweconomy_icon.png");
    let _infrastructure = require("@/assets/img/agenda/infrastruktura.png");
    let _innovations = require("@/assets/img/agenda/innovation_icon.png");
    let _visegradMeetings = require("@/assets/img/agenda/grupa-wyszechradzka.png");
    let _society = require("@/assets/img/agenda/society_icon.png");
    let _businessAndManagement = require("@/assets/img/agenda/business_icon.png");
    let _investments = require("@/assets/img/agenda/development_icon.png");
    let _europeIntegration = require("@/assets/img/agenda/europe_icon_ue.png");
    let _europeAndWorld = require("@/assets/img/agenda/europe_icon.png");
    let _international = require("@/assets/img/agenda/international_icon.png");
    let _plenarySession = require("@/assets/img/agenda/plenary_session.png");
    let _specialEvents = require("@/assets/img/agenda/special_events.png");
    let _slovakForum = require("@/assets/img/agenda/slovak_forum.png");

    let _cybersafety = require("@/assets/img/agenda/cybersafety.png");
    let _energy = require("@/assets/img/agenda/energy_icon.png");
    let _words = require("@/assets/img/agenda/words_icon.png");
    let _health = require("@/assets/img/agenda/health_icon.png");
    let _region = require("@/assets/img/agenda/region_icon.png");
    let _reforms = require("@/assets/img/agenda/reforms_icon.png");
    let _management = require("@/assets/img/agenda/management_icon.png");
    let _hungary = require("@/assets/img/agenda/wegry_icon.png");

    let _polonia = require("@/assets/img/agenda/polonia_icon.png");
    let _carpathians = require("@/assets/img/agenda/carpatian_icon.png");

    let _lesserPoland = require("@/assets/img/agenda/lesserpoland_icon.png");
    let _sgh = require("@/assets/img/agenda/sgh_icon.png");

    let _culturalEvents = require("@/assets/img/agenda/culture_icon.png");

    let _default = require("@/assets/img/agenda/neweconomy_icon.png");

    let s = [
        { value: "gospodarka", text: _economy },
        { value: "economy", text: _economy },
        { value: "nowa gospodarka", text: _economy },
        { value: "new economy", text: _economy },
        { value: "infrastruktura", text: _infrastructure },
        { value: "infrastructure", text: _infrastructure },
        { value: "innowacje", text: _innovations },
        { value: "innovations", text: _innovations },
        { value: "forum innowacji", text: _innovations },
        { value: "innovations forum", text: _innovations },
        { value: "wyszehradzkie spotkania gospodarcze", text: _visegradMeetings },
        { value: "gospodarcze spotkania wyszehradzkie", text: _visegradMeetings },
        { value: "economic visegrad meetings", text: _visegradMeetings },
        { value: "społeczeństwo", text: _society },
        { value: "society", text: _society },
        { value: "biznes i zarządzanie", text: _businessAndManagement },
        { value: "business and management", text: _businessAndManagement },
        { value: "inwestycje", text: _investments },
        { value: "investments", text: _investments },
        { value: "integracja europejska i reformy", text: _europeIntegration },
        { value: "european integration and reforms", text: _europeIntegration },
        { value: "inwestycje i rozwój", text: _investments },
        { value: "investments and development", text: _investments },
        { value: "polityka międzynarodowa i bezpieczeństwa", text: _international },
        { value: "polityka międzynarodowa i bezpieczeństwo", text: _international },
        { value: "international politics and security", text: _international },
        { value: "sesje plenarne", text: _plenarySession },
        { value: "plenary sessions", text: _plenarySession },
        { value: "sesja plenarna", text: _plenarySession },
        { value: "plenary session", text: _plenarySession },
        { value: "wydarzenia specjalne", text: _specialEvents },
        { value: "special events", text: _specialEvents },
        { value: "wydarzenie specjalne", text: _specialEvents },
        { value: "special event", text: _specialEvents },
        { value: "ii forum słowackie", text: _slovakForum },
        { value: "slovak forum", text: _slovakForum },
        { value: "cultural events", text: _culturalEvents },
        { value: "wydarzenia kulturalne", text: _culturalEvents },
        { value: "biznes i inwestycje", text: _businessAndManagement },
        { value: "business and investments", text: _businessAndManagement },
        { value: "europa i świat", text: _europeAndWorld },
        { value: "europe and world", text: _europeAndWorld },
        { value: "polityka międzynarodowa", text: _international },
        { value: "international politics", text: _international },
        { value: "forum zarządzania", text: _management },
        { value: "management forum", text: _management },

        { value: "forum cyberbezpieczeństwa", text: _cybersafety },
        { value: "cybersecurity forum", text: _cybersafety },
        { value: "forum energetyczne", text: _energy },
        { value: "energy forum", text: _energy },
        { value: "forum mediów i komunikacji", text: _words },
        { value: "media and communication forum", text: _words },
        { value: "forum ochrony zdrowia", text: _health },
        { value: "healthcare forum", text: _health },
        { value: "forum regionów", text: _region },
        { value: "regions forum", text: _region },
        { value: "państwo i reformy", text: _reforms },
        { value: "state and reforms", text: _reforms },
        { value: "forum polska-węgry", text: _hungary },
        { value: "poland-hungary forum", text: _hungary },

        { value: "polityka międzynarodowa i energetyczna", text: _international },
        { value: "international politics and energy", text: _international },
        { value: "forum polonijne", text: _polonia },
        { value: "international polish community forum", text: _polonia },
        { value: "europa karpat", text: _carpathians },
        { value: "europe of the carpathians", text: _carpathians },

        { value: "małopolska region meeting space", text: _lesserPoland },
        { value: "małopolska strefa spotkań", text: _lesserPoland },
        { value: "sgh zone", text: _sgh },
        { value: "strefa sgh", text: _sgh },
        { value: "współpraca międzynarodowa i regionalna", text: _words },
        { value: "international and regional cooperation", text: _words }
    ];

    let matches = s.filter(i => i.value == val?.toLowerCase());
    return matches.length ? matches[0].text : _default;
});